<template>
  <v-btn v-bind="props" :href="item.link" target="_blank">
    {{
    item.name
    }}
  </v-btn>
</template>

<script>
export default {
  name: 'FileMenuButton',
  props: {
    item: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
